import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {useHistory, useParams} from "react-router-dom";
import {ProgressBar} from "primereact/progressbar";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Checkbox} from "primereact/checkbox";
import axios from "axios";
import {getCrmContrastTextColor} from '../crmFormatters';

const CampaigShowComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [campaign, setCampaign] = useState({});
  const [leads, setLeads] = useState(false);
  const [steps, setSteps] = useState(false);
  const [actions, setActions] = useState(false);

  const actionShow = (stepId, leadId) => {
    if (actions && actions[0]) {
      let action = actions.filter(item => item.crm_campaign_step?.id === stepId && item.lead.id === leadId)
      return action;
    }
  }

  useEffect(() => {
    setLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/crm-campaign/" + id,
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setCampaign(response.data.data)
        const sortedSteps = response.data.data.campaign_steps.sort((a, b) => (a.position || 0) - (b.position || 0));
        setSteps(sortedSteps)
        setLeads(response.data.data.leads)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/crm-action/",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setActions(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [window.App.state.rerenderActionList, window.App.state.rerenderLeadList])

  return (
    <>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <h3 className={"text-primary p-my-0"}>
        {campaign.name}
      </h3>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('goal')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {campaign?.deal?.name}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('comment')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {campaign.description}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('category')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {campaign?.category?.name}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            Kezdete
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {window.App.formatDateValue(campaign.start_date)}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('end')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {window.App.formatDateValue(campaign.end_date)}
          </p>
        </div>
      </div>
      {steps && steps[0] && leads && leads[0] &&
        <>
          <DataTable value={leads}
                     className="p-datatable campaigns"
                     responsiveLayout="scroll"
                     loading={loading}
                     showGridlines
                     emptyMessage={t('noResults')}
          >
            <Column field="partner.name"
                    header=""
                    className={"p-valign-middle"}
                    body={(lead) => {
                      return (
                        <div className={"lead successful-" + lead.successful}>
                          <a onClick={() => {
                            if(action && id) {
                              history.push('/crm/'+ entity + '/' + action + '/' + id + '?show=partner&partnerId=' + lead?.partner?.id)
                            } else {
                              history.push('/crm/'+ entity + '?show=partner&partnerId=' + lead?.partner?.id)
                            }
                          }}>
                            {lead.partner.name}
                          </a>
                        </div>
                      )
                    }}/>
            {steps.map((step) => {
              return (
                <Column
                  key={step.id}
                  style={{
                    position: 'relative',
                  }}
                  header={() => {
                    return (
                      <>
                        {/*<div style={{*/}
                        {/*  position: 'absolute',*/}
                        {/*  backgroundColor: step.color,*/}
                        {/*  height: '100%',*/}
                        {/*  width: '10px',*/}
                        {/*  top: 0,*/}
                        {/*  left: 0,*/}
                        {/*}}>*/}
                        {/*</div>*/}
                        {/*<div className={"p-pl-2"}>*/}
                        {step.name}
                        {/*</div>*/}
                      </>
                    )
                  }}
                  body={(lead) => {
                    const _actions = actionShow(step.id, lead.id);
                    return (
                      <div className={"action-container"}>
                        {_actions && _actions[0] &&
                          <>
                            {_actions.map((action) => {
                              return (
                                <div key={action.id}
                                     className={"p-p-3 p-my-2 action position-relative successful-" + action.successful}
                                     style={{
                                       borderTopRightRadius: '4px',
                                       borderBottomRightRadius: '4px',
                                       border: '1px solid ' + step.color,
                                       //borderLeft: '10px solid ' + step.color,
                                       position: 'relative',
                                     }}>
                                  <span className="p-d-block">{action.subject?.name}</span>
                                  <span className="p-d-block">{action.date}</span>
                                  <span className="p-d-block">{action.note}</span>
                                  <Checkbox disabled={action.successful}
                                            onChange={e => {
                                              if (window.confirm('Biztos? A művelet nem vonható vissza!')) {
                                                axios.patch(process.env.REACT_APP_API_HOST + "/api/v2/crm-action/" + action.id,
                                                  {
                                                    successful: e.checked,
                                                  },
                                                  {
                                                    params: {},
                                                    headers: {
                                                      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                                      'App-Network': localStorage.getItem("networkId")
                                                    }
                                                  })
                                                  .then(response => {
                                                    window.App.toastShow('success', t('toastSaveSuccess'));
                                                    window.App.setState({rerenderActionList: Math.random()});
                                                  })
                                                  .catch(error => {
                                                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                                  })
                                              }
                                            }}
                                            style={{position: 'absolute', top: '10px', right: '10px'}}
                                            checked={action.successful === true ? true : false}>
                                  </Checkbox>
                                </div>
                              )
                            })}
                          </>
                        }
                        <a onClick={() => {
                          history.push('/crm/campaign/read/' + id + '?create=action&stepId=' + step.id + '&leadId=' + lead.id)
                        }}
                           style={{backgroundColor: step.color, borderColor: step.color, color: getCrmContrastTextColor(step.color)}}
                           className={"p-button p-button-success p-button-sm p-my-2 p-d-block w-100"}
                        >
                          <i className={"pi pi-plus"}></i>
                          &nbsp;
                          {t('addNamed', {name: step.name.toLowerCase()})}
                        </a>
                      </div>
                    )
                    return null;
                  }}
                />
              )
            })}
          </DataTable>
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <a onClick={() => {
                history.push('/crm/campaign/read/' + id + '?create=lead&campaignId=' + id)
              }}
                 style={{maxWidth: '250px'}}
                 className={"p-button p-button-success p-button-sm p-my-2 p-d-block w-100"}
              >
                <i className={"pi pi-plus"}></i>
                &nbsp;
                {t('addLead')}
              </a>
            </div>
          </div>
        </>
      }
    </>
  )
}
export default withTranslation('common')(CampaigShowComponent);
